<template>
  <b-row
    v-if="Object.keys(data).length"
    class="b-row-other w-100 m-0 mb-2 py-3"
    align-h="center"
    align-v="center"
  >
    <b-col
      class="text-center mb-md-0 mb-1 pb-md-0 pb-2 sm_border_bottom"
      md=""
      cols="12"
    >
      <label
        class="mb-1"
        v-text="$lang.searchinterviewDone.interview_location_plan_id"
      />
      <b-button
        variant="secondary"
        pill
        block
        v-text="data.interview_location_plan_id"
      />
    </b-col>
    <b-col
      class="text-center mb-md-0 mb-1 pb-md-0 pb-2 sm_border_bottom"
      md=""
      cols="12"
    >
      <label class="mb-1" v-text="$lang.searchinterviewDone.place_caption" />
      <b-button
        variant="secondary"
        pill
        block
        v-text="data.location_caption"
      />
    </b-col>
    <b-col
      class="text-center mb-md-0 mb-1 pb-md-0 pb-2 sm_border_bottom"
      md=""
      cols="12"
    >
      <label class="mb-1" v-text="$lang.searchinterviewDone.city_name" />
      <b-button
        variant="secondary"
        pill
        block
        v-text="data.location_city"
      />
    </b-col>
    <b-col
      class="text-center mb-md-0 mb-1 pb-md-0 pb-2 sm_border_bottom"
      md=""
      cols="12"
    >
      <label
        class="mb-1"
        v-text="$lang.interview_location_plan_interview_date"
      />
      <b-button
        variant="secondary"
        pill
        block
        v-text="data.interview_date && data.interview_date.jalali"
      />
    </b-col>
    <b-col class="text-center" md="" cols="12">
      <label class="mb-1" v-text="$lang.searchinterviewDone.room_number" />
      <b-button
        variant="secondary"
        pill
        block
        v-text="data.room_number"
      />
    </b-col>
  </b-row>
</template>

<script>
export default {
  props: {
    data: {
      type: Object,
      default: () => {},
    },
  },
};
</script>

<style lang="scss">
.b-row-other {
  background-color: #f0f3f5;
  border-radius: 7px;
  color: black;

  label {
    color: #555555;
  }

  .btn-secondary{
    color: black;
  }
}

@media (max-width: 575.98px) {
  .sm_border_bottom {
    border-bottom: 1px solid #b1b1b1;
  }
}
</style>